import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { getUriWithPageAndParams } from '../../shared/utilities/urlParams.utility';
import { ParameterBag } from '../../shared/models/ParameterBag.interface';
import { UserRoleService } from '../../shared/services/user-role.service';
import { OrderComment } from '../models';

@Injectable({
  providedIn: 'root'
})
export class OrderCommentsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createOrderComment(payload: any): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ORDER_COMMENT_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/order_comments`, payload)
    );
  }

  readOrderComment(iri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ORDER_COMMENT_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readOrderComments(
    page = 1,
    params?: ParameterBag
  ): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ORDER_COMMENT_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(
              getUriWithPageAndParams('/order_comments', page, params)
            )
    );
  }

  readOrderCommentChunk(uri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ORDER_COMMENT_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(uri, true)
    );
  }

  updateOrderComment(
    iri: string,
    payload: OrderComment
  ): Observable<AbstractApiResponse> {
    // every user should edit their comments, so no role-based Security possible ROLE: ROLE_MWS_ORDER_COMMENT_EDIT
    return this.apiService.updateObject(iri, payload, true);
  }

  deleteOrderComment(iri: string): Observable<AbstractApiResponse> {
    // every user should edit their comments, so no role-based Security possible ROLE: ROLE_MWS_ORDER_COMMENT_DELETE
    return this.apiService.deleteObject(iri, true);
  }
}
